import React, { useEffect, useRef } from 'react';
import helpImage from '../../photos/rost.svg';
import rostImage from '../../photos/help.svg';

const values = [
  { icon: rostImage, text: 'Фахова підтримка бухгалтерського обліку від професіоналів - це те, що вам потрібно, щоб оптимізувати та систематизувати ваш бізнес.' },
  { icon: helpImage, text: 'Ми забезпечимо вас всіма необхідними інструментами та використаємо весь наш багаторічний досвід, щоб ваш бізнес процвітав!' },
];

function ProductValuesBuh() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.buh-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: '#0a0a0f',
    }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: 32,
        }}>
          {values.map((val, i) => (
            <div key={i} className="buh-card" style={{
              opacity: 0,
              transform: 'translateY(40px)',
              transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
              padding: 40,
              borderRadius: 20,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              textAlign: 'center',
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = 'rgba(22,183,36,0.06)';
              e.currentTarget.style.borderColor = 'rgba(22,183,36,0.2)';
              e.currentTarget.style.transform = 'translateY(-4px)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <div style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'rgba(22,183,36,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
              }}>
                <img src={val.icon} alt="" style={{ height: 40, filter: 'brightness(0) invert(1)' }} />
              </div>
              <p style={{
                color: '#4dc247',
                fontSize: 16,
                lineHeight: 1.7,
                fontWeight: 500,
              }}>
                {val.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductValuesBuh;
